export enum OptionOrderCostEnum {
  totalCost = 'totalCost',
  bookingCost = 'bookingCost.cost',
}
export type OptionOrderEnumType = keyof typeof OptionOrderCostEnum;

export enum OptionOrderProductTypeEnum {
  flights = 'Flights',
}
export type OptionOrderProductTypeEnumType = keyof typeof OptionOrderProductTypeEnum;

export enum OptionOrderContactDetailsEnum {
  phoneNumber = 'phoneNumber',
  emailAddress = 'emailAddress',
}
export type OptionOrderContactDetailsEnumType = keyof typeof OptionOrderContactDetailsEnum;
